import { FastField } from 'formik';
import { SttInput } from '@stt-componentes/core';
import { FUNCIONARIO_ENVIO } from '../fieldNames';

const ResponsavelEnvio = ({ strings }) => {
    
    return (
        <FastField name={FUNCIONARIO_ENVIO}>
            {({
                field
            }) => (
                <SttInput
                    {...field}
                    label={strings.responsavelEnvio}
                />
            )}
        </FastField>
    );
};

export default ResponsavelEnvio;